<template>
  <div @keyup.enter="loginJWT">
    <vs-input
      v-validate="'required|phone:mobile'"
      data-vv-validate-on="blur"
      name="phone"
      icon-no-border
      icon="icon icon-user"
      icon-pack="feather"
      :label-placeholder="$t('users.phone')"
      :data-vv-as="$t('users.phone')"
      v-model="phone"
      @keyup="phone = translateNumbers(phone)"
      class="w-full"
    />
    <span class="text-danger text-sm">{{ errors.first('phone') }}</span>

    <vs-input
      data-vv-validate-on="blur"
      v-validate="'required|min:8'"
      type="password"
      name="password"
      icon-no-border
      icon="icon icon-lock"
      icon-pack="feather"
      :label-placeholder="$t('users.password')"
      :data-vv-as="$t('users.password')"
      v-model="password"
      class="w-full mt-6"
    />
    <span class="text-danger text-sm">{{ errors.first('password') }}</span>

    <div class="flex flex-wrap justify-between my-5">
      <vs-checkbox v-model="checkbox_remember_me" class="mb-3">{{ $t('auth.remember_me') }}</vs-checkbox>
      <router-link to="/pages/forgot-password">{{ $t('auth.forgot_password') }}</router-link>
    </div>
    <div class="flex flex-wrap justify-between mb-3">
      <vs-button
        id="button-with-loading"
        class="vs-con-loading__container"
        :disabled="!validateForm || disabled_btn"
        @click="loginJWT"
        >{{ $t('button.log_in') }}</vs-button
      >
      <vs-button type="border" @click="registerUser">{{ $t('button.register') }}</vs-button>
    </div>
  </div>
</template>

<script>
import { TranslateNumbers } from '@/utils'

export default {
  data() {
    return {
      phone: '',
      password: '',
      checkbox_remember_me: true,
      backgroundLoading: 'primary',
      colorLoading: '#fff',
      disabled_btn: false
    }
  },
  computed: {
    validateForm() {
      return !this.errors.any() && this.phone !== '' && this.password !== ''
    }
  },
  methods: {
    loginJWT() {
      this.disabled_btn = true
      // Loading
      this.$vs.loading({
        background: this.backgroundLoading,
        container: '#button-with-loading',
        color: this.colorLoading,
        scale: 0.45
      })

      const payload = {
        checkbox_remember_me: this.checkbox_remember_me,
        userDetails: {
          phone: this.phone,
          password: this.password
        }
      }

      this.$store
        .dispatch('auth/loginJWT', payload)
        .then(() => {
          if (this.$route.query.to) window.location = this.$route.query.to
          else this.$router.push('/').catch(() => {})
        })
        .finally(() => {
          this.$vs.loading.close('#button-with-loading > .con-vs-loading')
          this.disabled_btn = false
        })
    },
    registerUser() {
      this.$router.push({ name: 'page-register' }).catch(() => {})
    },
    translateNumbers(val) {
      return TranslateNumbers(val)
    }
  }
}
</script>
